module.exports = __webpack_public_path__ + "img/soth-logo-blue.ca5759dd.png";